import * as React from 'react';
import {View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {AcceptorCard} from '../../../../shared/components/acceptorCard';
import {Button} from '../../../../shared/components/button';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {useStyles} from '../../../../shared/hooks/styles';
import {AcceptorResponsePayload} from '../../../../shared/models/api';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {Screens} from '../../../../shared/routing';

const itemBaseWidth = 315;
const itemHorizontalSpacing = 20;

const calcItemFlexBasis = (containerWidth: number): `${number}%` => {
  const itemPerRow = Math.floor(containerWidth / itemBaseWidth);
  return `${100 / itemPerRow}%`;
};

interface Props {
  acceptorsList: AcceptorResponsePayload[] | null;
  onShowMore: () => void;
  canShowMore: boolean;
}

export default ({acceptorsList, onShowMore, canShowMore}: Props) => {
  const nav = useNavigation();
  const deviceSize = useDeviceSize();
  const [itemFlexBasis, setItemFlexBasis] = React.useState<`${number}%`>(
    deviceSize === DeviceSize.desktop ? '25%' : '100%',
  );
  const styles = useStyles(({mediaOnly}) => {
    return {
      container: {
        maxWidth: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        ...mediaOnly(DeviceSize.desktop, {minHeight: 200}, {}),
      },
      item: {
        marginVertical: 10,
        flexGrow: 0,
        flexShrink: 0,
        //opacity: 0.5,
        ...mediaOnly(
          DeviceSize.mobile,
          {
            flexBasis: '100%',
          },
          {
            paddingHorizontal: itemHorizontalSpacing / 2,
            flexBasis: itemFlexBasis || itemBaseWidth,
          },
        ),
      },
      itemCard: {
        flex: 1,
      },
      buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        ...mediaOnly(
          DeviceSize.mobile,
          {paddingTop: 14, paddingBottom: 60},
          {paddingTop: 20, paddingBottom: 80, paddingHorizontal: 10},
        ),
      },
      showMoreButton: {
        marginLeft: 0,
        marginRight: 0,
        ...mediaOnly(DeviceSize.mobile, {width: '100%', maxWidth: 328}, {width: 200}),
      },
    };
  });

  return (
    <LoadableContent loading={!acceptorsList}>
      <View
        testID='acceptor-list-id'
        style={styles.container}
        onLayout={(event) => {
          if (deviceSize !== DeviceSize.mobile) {
            setItemFlexBasis(calcItemFlexBasis(event.nativeEvent.layout.width));
          }
        }}>
        {acceptorsList?.map((acceptor) => (
          <View style={styles.item} key={acceptor.id}>
            <AcceptorCard
              onPress={() => {
                nav.navigate(Screens.LoyaltyProgramAcceptor, {
                  id: acceptor.id,
                });
              }}
              style={styles.itemCard}
              acceptor={acceptor}
              useHoverEffect
            />
          </View>
        ))}
      </View>
      <View style={styles.buttonContainer}>
        {canShowMore && (
          <Button
            id='acceptor-list-more'
            onPress={onShowMore}
            style={styles.showMoreButton}
            type='secondary'
            text='Показать еще'
          />
        )}
      </View>
    </LoadableContent>
  );
};
